export default "__VITE_ASSET__4XR1HSsP__"